import React from "react";
import { jsx as ___EmotionJSX } from "@emotion/react";
var BrokenCamera = function BrokenCamera(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M119 129C53.2781 129 0 119.374 0 107.5C0 95.6259 53.2781 86 119 86C184.722 86 238 95.6259 238 107.5C238 119.374 184.722 129 119 129Z",
    fill: "#95D8ED"
  }), ___EmotionJSX("path", {
    d: "M213.924 20.3921H198.685L185.987 1.73157H160.012L147.313 20.3921H103.907C100.674 20.3921 98.0189 23.0746 98.0189 26.3401V94.9176C98.0189 98.1832 100.674 100.866 103.907 100.866H214.039C217.272 100.866 219.927 98.1832 219.927 94.9176V26.2235C219.812 22.9579 217.156 20.3921 213.924 20.3921Z",
    fill: "#fff",
    stroke: "#24547A",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), ___EmotionJSX("path", {
    d: "M123.472 27.1849H104.717V32.5435H123.472V27.1849Z",
    fill: "#fff",
    stroke: "#24547A",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), ___EmotionJSX("path", {
    d: "M119.453 90.1486H104.717V95.5072H119.453V90.1486Z",
    fill: "#fff",
    stroke: "#24547A",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), ___EmotionJSX("path", {
    d: "M173.039 95.5072C191.536 95.5072 206.53 80.5127 206.53 62.016C206.53 43.5193 191.536 28.5247 173.039 28.5247C154.542 28.5247 139.548 43.5193 139.548 62.016C139.548 80.5127 154.542 95.5072 173.039 95.5072Z",
    fill: "#fff",
    stroke: "#24547A",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), ___EmotionJSX("path", {
    d: "M173.039 88.8089C187.837 88.8089 199.832 76.8133 199.832 62.0159C199.832 47.2185 187.837 35.2229 173.039 35.2229C158.242 35.2229 146.246 47.2185 146.246 62.0159C146.246 76.8133 158.242 88.8089 173.039 88.8089Z",
    fill: "#94D8ED",
    stroke: "#24547A",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), ___EmotionJSX("path", {
    d: "M154.864 58.1475L146.645 56.0929C146.645 53.3534 148.426 46.5046 155.549 41.0256C162.671 35.5466 169.018 35.09 171.301 35.5466L174.725 42.3953V49.2441L171.986 47.8744L168.561 51.9836H165.822L154.864 56.0929V58.1475Z",
    fill: "#fff"
  }), ___EmotionJSX("path", {
    d: "M173.039 88.8089C187.837 88.8089 199.832 76.8133 199.832 62.0159C199.832 47.2185 187.837 35.2229 173.039 35.2229C158.242 35.2229 146.246 47.2185 146.246 62.0159C146.246 76.8133 158.242 88.8089 173.039 88.8089Z",
    stroke: "#24547A",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), ___EmotionJSX("path", {
    d: "M148.449 70.6978C149.007 69.8939 149.843 68.6643 150.688 67.3784M152.927 78.6082C153.86 78.4198 156.397 77.7041 159.083 76.3481C161.77 74.992 165.053 72.3929 166.359 71.2628L165.818 69.5678M160.943 54.3121L160.762 53.7471L155.166 56.0072C155.097 56.5578 154.974 57.37 154.802 58.2673M160.943 54.3121L165.8 51.487L167.185 53.1821M160.943 54.3121L164.68 66.0081M191.847 80.7484L184.269 74.088L175.727 63.635M167.185 53.1821L171.396 47.5319L174.195 49.2269M167.185 53.1821L175.727 63.635M198.011 69.7904L176.993 50.922L174.195 49.2269M174.195 49.2269L174.755 42.4466M174.755 42.4466L183.71 40.1865L190.426 41.8816M174.755 42.4466L171.396 36.2314M154.802 58.2673C154.503 59.8254 154.055 61.6402 153.487 62.7875C152.973 63.8238 151.823 65.6519 150.688 67.3784M154.802 58.2673L147.33 56.5722M150.688 67.3784C152.74 67.6185 158.412 67.6806 164.68 66.0081M164.68 66.0081L165.818 69.5678M165.818 69.5678C167.766 68.8144 172.475 66.5732 175.727 63.635",
    stroke: "#24547A",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), ___EmotionJSX("path", {
    d: "M214.568 16.4678H201.172V20.4868H214.568V16.4678Z",
    fill: "#fff",
    stroke: "#24547A",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), ___EmotionJSX("path", {
    d: "M182.252 8.42987H163.827L155.624 21.8264H190.455L182.252 8.42987Z",
    fill: "#fff",
    stroke: "#24547A",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), ___EmotionJSX("path", {
    d: "M182.252 8.42987H163.827L155.624 21.8264H190.455L182.252 8.42987Z",
    fill: "#fff",
    stroke: "#24547A",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), ___EmotionJSX("path", {
    d: "M19.0674 94.1088C11.3753 92.9277 6.80857 81.1005 8.86742 67.692C10.9263 54.2836 18.831 44.3713 26.5232 45.5525L19.0674 94.1088Z",
    fill: "#95D8ED",
    stroke: "#0C547D",
    strokeWidth: "2"
  }), ___EmotionJSX("path", {
    d: "M30.0947 100.829C18.7312 99.0841 11.5647 84.3484 14.0879 67.9158C16.6111 51.4832 27.8685 39.5764 39.232 41.3213C40.9321 41.5823 44.8284 42.1639 45.4815 42.3528L34.3078 101.541L30.0947 100.829Z",
    fill: "#95D8ED",
    stroke: "#0C547D",
    strokeWidth: "2"
  }), ___EmotionJSX("path", {
    d: "M43.3048 108.317C32.6657 106.683 26.3659 90.2176 29.2338 71.5402C32.1016 52.8629 43.0512 39.0462 53.6903 40.6798C57.2772 40.9908 59.3496 42.0116 60.3787 43.6252L51.3501 106.664C49.9179 108.304 47.451 108.953 43.3048 108.317Z",
    fill: "#fff",
    stroke: "#0C547D",
    strokeWidth: "2"
  }), ___EmotionJSX("path", {
    d: "M59.8302 110.196L70.1002 44.5897L64.9188 44.1527L50.745 60.8598L48.9748 97.0777L59.8302 110.196Z",
    fill: "#95D8ED"
  }), ___EmotionJSX("path", {
    d: "M50.3933 74.343C53.0791 56.8512 62.5636 43.5435 72.2536 42.9527L70.0136 42.4508C69.2417 42.3323 68.4681 42.2957 67.6959 42.337C67.1651 42.0657 65.844 41.4923 64.8063 41.3694C54.3552 39.7646 43.5324 53.7717 40.6329 72.6549C37.7334 91.5382 43.8552 108.147 54.3063 109.752C55.1683 109.884 55.971 109.796 56.3105 109.838C57.3264 110.325 58.396 110.662 59.5136 110.833C60.2307 110.804 60.3932 110.381 60.3848 110.174C52.2351 105.678 47.8536 90.8829 50.3933 74.343Z",
    fill: "#95D8ED"
  }), ___EmotionJSX("path", {
    d: "M67.6959 42.337C68.4681 42.2957 69.2417 42.3323 70.0136 42.4508L72.2536 42.9527C62.5636 43.5435 53.0791 56.8512 50.3933 74.343C47.8536 90.8829 52.2351 105.678 60.3848 110.174C60.3932 110.381 60.2307 110.804 59.5136 110.833C58.396 110.662 57.3264 110.325 56.3105 109.838M67.6959 42.337C57.808 42.8659 48.1585 56.1639 45.469 73.6794C42.8736 90.5822 47.6396 105.683 56.3105 109.838M67.6959 42.337C67.1651 42.0657 65.844 41.4923 64.8063 41.3694C54.3552 39.7646 43.5324 53.7717 40.6329 72.6549C37.7334 91.5382 43.8552 108.147 54.3063 109.752C55.1683 109.884 55.971 109.796 56.3105 109.838",
    stroke: "#0C547D",
    strokeWidth: "2"
  }), ___EmotionJSX("path", {
    d: "M62.3226 75.8854C65.0395 53.5717 77.1111 42.3712 82.8073 39.5601C78.958 40.1453 70.0379 43.043 65.1521 49.9526C59.0448 58.5895 51.9339 74.367 55.3154 94.2407C58.6969 114.114 65.2449 116.433 75.6336 117.951C69.0337 114.344 58.9265 103.778 62.3226 75.8854Z",
    fill: "#fff"
  }), ___EmotionJSX("path", {
    d: "M62.2551 75.1606C58.9096 96.9484 66.2585 116.156 78.6693 118.061C80.0255 118.27 81.3859 118.263 82.7379 118.057C93.759 116.377 104.219 101.469 107.199 82.0617C110.544 60.2739 103.195 41.0667 90.7844 39.161C78.3735 37.2553 65.6005 53.3729 62.2551 75.1606Z",
    fill: "#fff"
  }), ___EmotionJSX("path", {
    d: "M90.7844 39.161C80.7701 37.0601 68.9847 41.4071 61.7551 55.253C58.7629 60.9835 56.4902 67.8772 55.3291 75.4394C53.4197 87.8741 54.9196 99.4861 58.8256 107.654C61.9127 114.11 69.9373 120.762 82.7379 118.057M90.7844 39.161C103.195 41.0667 110.544 60.2739 107.199 82.0617C104.219 101.469 93.759 116.377 82.7379 118.057M90.7844 39.161C78.3735 37.2553 65.6005 53.3729 62.2551 75.1606C58.9096 96.9484 66.2585 116.156 78.6693 118.061C80.0255 118.27 81.3859 118.263 82.7379 118.057",
    stroke: "#0C547D",
    strokeWidth: "2"
  }), ___EmotionJSX("path", {
    d: "M64.4108 76.187C62.9849 85.4732 63.8477 94.1612 66.3452 100.689C68.8545 107.247 72.9167 111.42 77.7766 112.166C82.6364 112.913 87.7634 110.151 92.1249 104.647C96.4657 99.1697 99.8953 91.1408 101.321 81.8545C102.747 72.5683 101.884 63.8803 99.3869 57.3528C96.8775 50.7942 92.8153 46.6213 87.9555 45.8751C83.0957 45.1289 77.9687 47.8908 73.6072 53.3943C69.2663 58.8718 65.8367 66.9008 64.4108 76.187Z",
    fill: "#95D8ED",
    stroke: "#0C547D",
    strokeWidth: "2"
  }), ___EmotionJSX("path", {
    d: "M67.006 77.3347C65.9468 84.2329 66.5901 90.6743 68.4365 95.5C70.2947 100.357 73.274 103.373 76.7735 103.91C80.2731 104.447 84.02 102.464 87.2497 98.3888C90.4589 94.3394 93.0051 88.3877 94.0643 81.4895C95.1236 74.5913 94.4802 68.1499 92.6339 63.3242C90.7756 58.4675 87.7963 55.4516 84.2968 54.9143C80.7972 54.3769 77.0504 56.36 73.8206 60.4354C70.6115 64.4849 68.0652 70.4365 67.006 77.3347Z",
    fill: "#fff",
    stroke: "#0C547D",
    strokeWidth: "2"
  }));
};
BrokenCamera.defaultProps = {
  width: "238",
  height: "129",
  viewBox: "0 0 238 129",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { BrokenCamera };